module.exports = __webpack_public_path__ + "img/x.28d93f84.svg";